'use client';

var getLastViewJobId = function (lastViewCookie, userId) {
    if (!!lastViewCookie) {
        var lastViewJobData = decodeURIComponent(lastViewCookie).split(',');
        var jobId = lastViewJobData[0];
        var userViewJob = parseFloat(lastViewJobData[1]);
        var isAnonymous = !userId || userViewJob === 0;
        if (!isAnonymous && userId !== userViewJob) {
            return;
        }
        return jobId;
    }
    return;
};

export { getLastViewJobId };
//# sourceMappingURL=helper.js.map
